import { GrantsType, hasScopedPermission } from '../../../Shared/utils/auth';

export const editPolicyGaragingAddressPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'policies.edit_garaging_address');

export const editPolicyContactInfoPolicy = (grants: GrantsType) =>
  hasScopedPermission(
    grants,
    'partner',
    'policies.edit_policyholder_contact_info'
  );

export const editMultiLineDiscountPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'policies.edit_multiline_discount');
